/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Enumeration of countries known to the system.
 */
export enum EnumCountry {
    /**
     * Afghanistan
     */
    Afghanistan = 1,
    /**
     * Albania
     */
    Albania = 2,
    /**
     * Algeria
     */
    Algeria = 3,
    /**
     * AmericanSamoa
     */
    AmericanSamoa = 4,
    /**
     * Andorra
     */
    Andorra = 5,
    /**
     * Angola
     */
    Angola = 6,
    /**
     * Anguilla
     */
    Anguilla = 7,
    /**
     * Antarctica
     */
    Antarctica = 8,
    /**
     * AntiguaAndBarbuda
     */
    AntiguaAndBarbuda = 9,
    /**
     * Argentina
     */
    Argentina = 10,
    /**
     * Armenia
     */
    Armenia = 11,
    /**
     * Aruba
     */
    Aruba = 12,
    /**
     * Australia
     */
    Australia = 13,
    /**
     * Austria
     */
    Austria = 14,
    /**
     * Azerbaijan
     */
    Azerbaijan = 15,
    /**
     * Bahamas
     */
    Bahamas = 16,
    /**
     * Bahrain
     */
    Bahrain = 17,
    /**
     * Bangladesh
     */
    Bangladesh = 18,
    /**
     * Barbados
     */
    Barbados = 19,
    /**
     * Belarus
     */
    Belarus = 20,
    /**
     * Belgium
     */
    Belgium = 21,
    /**
     * Belize
     */
    Belize = 22,
    /**
     * Benin
     */
    Benin = 23,
    /**
     * Bermuda
     */
    Bermuda = 24,
    /**
     * Bhutan
     */
    Bhutan = 25,
    /**
     * Bolivia
     */
    Bolivia = 26,
    /**
     * BosniaAndHerzegovina
     */
    BosniaAndHerzegovina = 27,
    /**
     * Botswana
     */
    Botswana = 28,
    /**
     * Brazil
     */
    Brazil = 29,
    /**
     * BritishIndianOceanTerritory
     */
    BritishIndianOceanTerritory = 30,
    /**
     * BritishVirginIslands
     */
    BritishVirginIslands = 31,
    /**
     * Brunei
     */
    Brunei = 32,
    /**
     * Bulgaria
     */
    Bulgaria = 33,
    /**
     * BurkinaFaso
     */
    BurkinaFaso = 34,
    /**
     * Burundi
     */
    Burundi = 35,
    /**
     * Cambodia
     */
    Cambodia = 36,
    /**
     * Cameroon
     */
    Cameroon = 37,
    /**
     * Canada
     */
    Canada = 38,
    /**
     * CapeVerde
     */
    CapeVerde = 39,
    /**
     * CaymanIslands
     */
    CaymanIslands = 40,
    /**
     * CentralAfricanRepublic
     */
    CentralAfricanRepublic = 41,
    /**
     * Chad
     */
    Chad = 42,
    /**
     * Chile
     */
    Chile = 43,
    /**
     * China
     */
    China = 44,
    /**
     * ChristmasIsland
     */
    ChristmasIsland = 45,
    /**
     * CocosIslands
     */
    CocosIslands = 46,
    /**
     * Colombia
     */
    Colombia = 47,
    /**
     * Comoros
     */
    Comoros = 48,
    /**
     * CookIslands
     */
    CookIslands = 49,
    /**
     * CostaRica
     */
    CostaRica = 50,
    /**
     * Croatia
     */
    Croatia = 51,
    /**
     * Cuba
     */
    Cuba = 52,
    /**
     * Curacao
     */
    Curacao = 53,
    /**
     * Cyprus
     */
    Cyprus = 54,
    /**
     * CzechRepublic
     */
    Czechia = 55,
    /**
     * DemocraticRepublicOfTheCongo
     */
    DemocraticRepublicOfTheCongo = 56,
    /**
     * Denmark
     */
    Denmark = 57,
    /**
     * Djibouti
     */
    Djibouti = 58,
    /**
     * Dominica
     */
    Dominica = 59,
    /**
     * DominicanRepublic
     */
    DominicanRepublic = 60,
    /**
     * EastTimor
     */
    EastTimor = 61,
    /**
     * Ecuador
     */
    Ecuador = 62,
    /**
     * Egypt
     */
    Egypt = 63,
    /**
     * ElSalvador
     */
    ElSalvador = 64,
    /**
     * EquatorialGuinea
     */
    EquatorialGuinea = 65,
    /**
     * Eritrea
     */
    Eritrea = 66,
    /**
     * Estonia
     */
    Estonia = 67,
    /**
     * Ethiopia
     */
    Ethiopia = 68,
    /**
     * FalklandIslands
     */
    FalklandIslands = 69,
    /**
     * FaroeIslands
     */
    FaroeIslands = 70,
    /**
     * Fiji
     */
    Fiji = 71,
    /**
     * Finland
     */
    Finland = 72,
    /**
     * France
     */
    France = 73,
    /**
     * FrenchPolynesia
     */
    FrenchPolynesia = 74,
    /**
     * Gabon
     */
    Gabon = 75,
    /**
     * Gambia
     */
    Gambia = 76,
    /**
     * Georgia
     */
    Georgia = 77,
    /**
     * Germany
     */
    Germany = 78,
    /**
     * Ghana
     */
    Ghana = 79,
    /**
     * Gibraltar
     */
    Gibraltar = 80,
    /**
     * Greece
     */
    Greece = 81,
    /**
     * Greenland
     */
    Greenland = 82,
    /**
     * Grenada
     */
    Grenada = 83,
    /**
     * Guam
     */
    Guam = 84,
    /**
     * Guatemala
     */
    Guatemala = 85,
    /**
     * Guernsey
     */
    Guernsey = 86,
    /**
     * Guinea
     */
    Guinea = 87,
    /**
     * GuineaBissau
     */
    GuineaBissau = 88,
    /**
     * Guyana
     */
    Guyana = 89,
    /**
     * Haiti
     */
    Haiti = 90,
    /**
     * Honduras
     */
    Honduras = 91,
    /**
     * HongKong
     */
    HongKong = 92,
    /**
     * Hungary
     */
    Hungary = 93,
    /**
     * Iceland
     */
    Iceland = 94,
    /**
     * India
     */
    India = 95,
    /**
     * Indonesia
     */
    Indonesia = 96,
    /**
     * Iran
     */
    Iran = 97,
    /**
     * Iraq
     */
    Iraq = 98,
    /**
     * Ireland
     */
    Ireland = 99,
    /**
     * IsleOfMan
     */
    IsleOfMan = 100,
    /**
     * Israel
     */
    Israel = 101,
    /**
     * Italy
     */
    Italy = 102,
    /**
     * IvoryCoast
     */
    IvoryCoast = 103,
    /**
     * Jamaica
     */
    Jamaica = 104,
    /**
     * Japan
     */
    Japan = 105,
    /**
     * Jersey
     */
    Jersey = 106,
    /**
     * Jordan
     */
    Jordan = 107,
    /**
     * Kazakhstan
     */
    Kazakhstan = 108,
    /**
     * Kenya
     */
    Kenya = 109,
    /**
     * Kiribati
     */
    Kiribati = 110,
    /**
     * Kosovo
     */
    Kosovo = 111,
    /**
     * Kuwait
     */
    Kuwait = 112,
    /**
     * Kyrgyzstan
     */
    Kyrgyzstan = 113,
    /**
     * Laos
     */
    Laos = 114,
    /**
     * Latvia
     */
    Latvia = 115,
    /**
     * Lebanon
     */
    Lebanon = 116,
    /**
     * Lesotho
     */
    Lesotho = 117,
    /**
     * Liberia
     */
    Liberia = 118,
    /**
     * Libya
     */
    Libya = 119,
    /**
     * Liechtenstein
     */
    Liechtenstein = 120,
    /**
     * Lithuania
     */
    Lithuania = 121,
    /**
     * Luxembourg
     */
    Luxembourg = 122,
    /**
     * Macau
     */
    Macau = 123,
    /**
     * Macedonia
     */
    Macedonia = 124,
    /**
     * Madagascar
     */
    Madagascar = 125,
    /**
     * Malawi
     */
    Malawi = 126,
    /**
     * Malaysia
     */
    Malaysia = 127,
    /**
     * Maldives
     */
    Maldives = 128,
    /**
     * Mali
     */
    Mali = 129,
    /**
     * Malta
     */
    Malta = 130,
    /**
     * MarshallIslands
     */
    MarshallIslands = 131,
    /**
     * Mauritania
     */
    Mauritania = 132,
    /**
     * Mauritius
     */
    Mauritius = 133,
    /**
     * Mayotte
     */
    Mayotte = 134,
    /**
     * Mexico
     */
    Mexico = 135,
    /**
     * Micronesia
     */
    Micronesia = 136,
    /**
     * Moldova
     */
    Moldova = 137,
    /**
     * Monaco
     */
    Monaco = 138,
    /**
     * Mongolia
     */
    Mongolia = 139,
    /**
     * Montenegro
     */
    Montenegro = 140,
    /**
     * Montserrat
     */
    Montserrat = 141,
    /**
     * Morocco
     */
    Morocco = 142,
    /**
     * Mozambique
     */
    Mozambique = 143,
    /**
     * Myanmar
     */
    Myanmar = 144,
    /**
     * Namibia
     */
    Namibia = 145,
    /**
     * Nauru
     */
    Nauru = 146,
    /**
     * Nepal
     */
    Nepal = 147,
    /**
     * Netherlands
     */
    Netherlands = 148,
    /**
     * NetherlandsAntilles
     */
    NetherlandsAntilles = 149,
    /**
     * NewCaledonia
     */
    NewCaledonia = 150,
    /**
     * NewZealand
     */
    NewZealand = 151,
    /**
     * Nicaragua
     */
    Nicaragua = 152,
    /**
     * Niger
     */
    Niger = 153,
    /**
     * Nigeria
     */
    Nigeria = 154,
    /**
     * Niue
     */
    Niue = 155,
    /**
     * NorthKorea
     */
    NorthKorea = 156,
    /**
     * NorthernMarianaIslands
     */
    NorthernMarianaIslands = 157,
    /**
     * Norway
     */
    Norway = 158,
    /**
     * Oman
     */
    Oman = 159,
    /**
     * Pakistan
     */
    Pakistan = 160,
    /**
     * Palau
     */
    Palau = 161,
    /**
     * Palestine
     */
    Palestine = 162,
    /**
     * Panama
     */
    Panama = 163,
    /**
     * PapuaNewGuinea
     */
    PapuaNewGuinea = 164,
    /**
     * Paraguay
     */
    Paraguay = 165,
    /**
     * Peru
     */
    Peru = 166,
    /**
     * Philippines
     */
    Philippines = 167,
    /**
     * Pitcairn
     */
    Pitcairn = 168,
    /**
     * Poland
     */
    Poland = 169,
    /**
     * Portugal
     */
    Portugal = 170,
    /**
     * PuertoRico
     */
    PuertoRico = 171,
    /**
     * Qatar
     */
    Qatar = 172,
    /**
     * RepublicOfTheCongo
     */
    RepublicOfTheCongo = 173,
    /**
     * Reunion
     */
    Reunion = 174,
    /**
     * Romania
     */
    Romania = 175,
    /**
     * Russia
     */
    Russia = 176,
    /**
     * Rwanda
     */
    Rwanda = 177,
    /**
     * SaintBarthelemy
     */
    SaintBarthelemy = 178,
    /**
     * SaintHelena
     */
    SaintHelena = 179,
    /**
     * SaintKittsAndNevis
     */
    SaintKittsAndNevis = 180,
    /**
     * SaintLucia
     */
    SaintLucia = 181,
    /**
     * SaintMartin
     */
    SaintMartin = 182,
    /**
     * SaintPierreAndMiquelon
     */
    SaintPierreAndMiquelon = 183,
    /**
     * SaintVincentAndTheGrenadines
     */
    SaintVincentAndTheGrenadines = 184,
    /**
     * Samoa
     */
    Samoa = 185,
    /**
     * SanMarino
     */
    SanMarino = 186,
    /**
     * SaoTomeAndPrincipe
     */
    SaoTomeAndPrincipe = 187,
    /**
     * SaudiArabia
     */
    SaudiArabia = 188,
    /**
     * Senegal
     */
    Senegal = 189,
    /**
     * Serbia
     */
    Serbia = 190,
    /**
     * Seychelles
     */
    Seychelles = 191,
    /**
     * SierraLeone
     */
    SierraLeone = 192,
    /**
     * Singapore
     */
    Singapore = 193,
    /**
     * SintMaarten
     */
    SintMaarten = 194,
    /**
     * Slovakia
     */
    Slovakia = 195,
    /**
     * Slovenia
     */
    Slovenia = 196,
    /**
     * SolomonIslands
     */
    SolomonIslands = 197,
    /**
     * Somalia
     */
    Somalia = 198,
    /**
     * SouthAfrica
     */
    SouthAfrica = 199,
    /**
     * SouthKorea
     */
    SouthKorea = 200,
    /**
     * SouthSudan
     */
    SouthSudan = 201,
    /**
     * Spain
     */
    Spain = 202,
    /**
     * SriLanka
     */
    SriLanka = 203,
    /**
     * Sudan
     */
    Sudan = 204,
    /**
     * Suriname
     */
    Suriname = 205,
    /**
     * SvalbardAndJanMayen
     */
    SvalbardAndJanMayen = 206,
    /**
     * Swaziland
     */
    Swaziland = 207,
    /**
     * Sweden
     */
    Sweden = 208,
    /**
     * Switzerland
     */
    Switzerland = 209,
    /**
     * Syria
     */
    Syria = 210,
    /**
     * Taiwan
     */
    Taiwan = 211,
    /**
     * Tajikistan
     */
    Tajikistan = 212,
    /**
     * Tanzania
     */
    Tanzania = 213,
    /**
     * Thailand
     */
    Thailand = 214,
    /**
     * Togo
     */
    Togo = 215,
    /**
     * Tokelau
     */
    Tokelau = 216,
    /**
     * Tonga
     */
    Tonga = 217,
    /**
     * TrinidadAndTobago
     */
    TrinidadAndTobago = 218,
    /**
     * Tunisia
     */
    Tunisia = 219,
    /**
     * Turkey
     */
    Turkey = 220,
    /**
     * Turkmenistan
     */
    Turkmenistan = 221,
    /**
     * TurksAndCaicosIslands
     */
    TurksAndCaicosIslands = 222,
    /**
     * Tuvalu
     */
    Tuvalu = 223,
    /**
     * USVirginIslands
     */
    USVirginIslands = 224,
    /**
     * Uganda
     */
    Uganda = 225,
    /**
     * Ukraine
     */
    Ukraine = 226,
    /**
     * UnitedArabEmirates
     */
    UnitedArabEmirates = 227,
    /**
     * UnitedKingdom
     */
    UnitedKingdom = 228,
    /**
     * UnitedStates
     */
    UnitedStates = 229,
    /**
     * Uruguay
     */
    Uruguay = 230,
    /**
     * Uzbekistan
     */
    Uzbekistan = 231,
    /**
     * Vanuatu
     */
    Vanuatu = 232,
    /**
     * Vatican
     */
    Vatican = 233,
    /**
     * Venezuela
     */
    Venezuela = 234,
    /**
     * Vietnam
     */
    Vietnam = 235,
    /**
     * WallisAndFutuna
     */
    WallisAndFutuna = 236,
    /**
     * WesternSahara
     */
    WesternSahara = 237,
    /**
     * Yemen
     */
    Yemen = 238,
    /**
     * Zambia
     */
    Zambia = 239,
    /**
     * Zimbabwe
     */
    Zimbabwe = 240,
}
